import React, { useEffect, useState } from "react";
import {
  IconDotsVertical,
  IconPencil,
  IconEyeOff,
  IconEye,
  IconClearAll,
  IconInbox,
  IconBorderCorners,
  IconRestore,
  IconTrash,
  IconBan,
} from "@tabler/icons-react";
import { useAuth } from "../../../../Auth/AuthProvider";
import SetRequest from "../../../../_Firestore/setRequest";
import DeleteRequest from "../../../../_Firestore/deleteRequest";
import { buttonVariants } from "@/Components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/Components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import EditRequestDialog from "./EditRequestDialog";
import { hasPayload } from "../../../../utils/requestPayload";

export default function RequestItemMenu(props) {
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const { uid } = useAuth();

  useEffect(() => {
    if (!props.visible) setOpen(false);
  }, [props.visible]);

  const setStatus = (status) =>
    SetRequest.status(props.request_id, status, uid);
  const setOpenedAt = (opened_at) =>
    SetRequest.opened_at(props.request_id, opened_at, uid);
  const setPayload = (payload) =>
    SetRequest.payload(props.request_id, payload, uid);
  const deleteRequest = () => DeleteRequest.hard(props.request_id, uid);

  return (
    <div
      className={cn(
        "absolute right-3 top-3 transition-opacity duration-300",
        props.visible ? "opacity-100" : "pointer-events-none opacity-0"
      )}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
        <DropdownMenuTrigger
          aria-label="Request actions"
          className={cn(buttonVariants({ variant: "secondary", size: "icon" }))}
        >
          <IconDotsVertical />
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end" className="min-w-52">
          {props.status >= 1 && (
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={() => setEditOpen(true)}>
                <IconPencil />
                Edit
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </DropdownMenuGroup>
          )}

          {props.status > 1 && (
            <DropdownMenuGroup>
              {props.opened_at ? (
                <DropdownMenuItem onClick={() => setOpenedAt(null)}>
                  <IconEyeOff />
                  Mark as unread
                </DropdownMenuItem>
              ) : (
                <DropdownMenuItem onClick={() => setOpenedAt(Date.now())}>
                  <IconEye />
                  Mark as read
                </DropdownMenuItem>
              )}

              {hasPayload(props.payload) ? (
                <DropdownMenuItem onClick={() => setPayload(null)}>
                  <IconClearAll />
                  Remove picks
                </DropdownMenuItem>
              ) : null}

              <DropdownMenuSeparator />
            </DropdownMenuGroup>
          )}

          <DropdownMenuGroup>
            {props.status > 1 && (
              <DropdownMenuItem onClick={() => setStatus(1)}>
                <IconInbox />
                Archive Request
              </DropdownMenuItem>
            )}
            {props.status === 1 && (
              <DropdownMenuItem onClick={() => setStatus(2)}>
                <IconBorderCorners />
                Move to Active Requests
              </DropdownMenuItem>
            )}
            {props.status === 0 && (
              <DropdownMenuItem onClick={() => setStatus(2)}>
                <IconRestore />
                Restore Request
              </DropdownMenuItem>
            )}
            {props.status >= 1 && (
              <DropdownMenuItem onClick={() => setStatus(0)}>
                <IconTrash />
                Move to Trash
              </DropdownMenuItem>
            )}
          </DropdownMenuGroup>

          {props.status <= 0 && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuGroup>
                <DropdownMenuItem
                  variant="destructive"
                  onClick={deleteRequest}
                >
                  <IconBan />
                  Delete Request
                </DropdownMenuItem>
              </DropdownMenuGroup>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      <EditRequestDialog
        open={editOpen}
        onOpenChange={setEditOpen}
        requestId={props.request_id}
        title={props.title}
        recipient={props.recipient}
      />
    </div>
  );
}
